// extracted by mini-css-extract-plugin
export default {"container":"not-allowed-screen_container__Rwgsw","card":"not-allowed-screen_card__hjt2q","text":"not-allowed-screen_text__90fVH"};